export default __webpack_public_path__ + "static/media/overcometheodds.8abd9d17.png";